(function () {
    "use strict";


    // @ngInject
    function CompanyServiceCtor(ModalService, _, PubSubService, Enums, AnalyticsService, CompaniesManager, Gon) {

        this.ModalService = ModalService;
        this._ = _;
        this.Enums = Enums;
        this.PubSubService = PubSubService;
        this.AnalyticsService = AnalyticsService;
        this.CompaniesManager = CompaniesManager;
        this.Gon = Gon;

        //Note the order in this array is not the order of the real enum numbers,
        //but rather the order in which the company types are presented in menus
        //i.e. DO NOT rely on this for code like "companyTypeEnum[company.company_type_cd]"

        // order is used in the directory for ordering the type filters

        this.companyTypeEnum = this.Gon.company_type_enum;

        this.companyTypeKeyEnum = {
            eventPlanner: 'event_planner',
            cake: 'cake',
            venue: 'venue',
            photographer: 'photographer',
            cinematography: 'cinematography',
            eventLighting: 'event_lighting',
            rental: 'rental',
            hairMakeup: 'hair_makeup',
            florist: 'florist',
            djMusician: 'dj_musician',
            caterer: 'caterer',
            stationery: 'stationery',
            fashion: 'fashion',
            officiant: 'officiant',
            photoBooth: 'photo_booth',
            other: 'other',
            marketing: 'marketing',
            visualArtist: 'visual_artist',
            blogger: 'blogger',
            businessConsultant: 'business_consultant',
            calligrapher: 'calligrapher',
            interiorDesigner: 'interior_designer',
            graphicDesigner: 'graphic_designer',
            makerArtisan: 'maker_artisan',
            webDesigner: 'web_designer',
            accounting: 'accounting',
            catering: 'catering',
            coaching: 'coaching',
            wellness: 'wellness',
            agency: 'agency',
            doula: 'doula',
            landscaper: 'lawn_landscaping'
        };

        this.companyTypeTranslationMap = {};
        this.companyTypeEnum.forEach(function (entry) {
            this.companyTypeTranslationMap[entry.key] = entry.text;
        }.bind(this));

        this.companyTypeInformalTranslationMap = {};
        this.companyTypeEnum.forEach(function (entry) {
            this.companyTypeInformalTranslationMap[entry.key] = entry.textInformal;
        }.bind(this));

        this.companyTypeIconMap = {};
        this.companyTypeEnum.forEach(function (entry) {
            this.companyTypeIconMap[entry.key] = entry.icon;
        }.bind(this));

        this.basicUser = {
            cd: 0,
            name: 'basic',
            text: 'COMPANY_SETTING.TEAM.PERMISSIONS._BASIC_',
            description: 'COMPANY_SETTING.TEAM.PERMISSIONS._BASIC_DESCRIPTION_'
        };

        this.moderator = {
            cd: 1,
            name: 'moderator',
            text: 'COMPANY_SETTING.TEAM.PERMISSIONS._MODERATOR_',
            description: 'COMPANY_SETTING.TEAM.PERMISSIONS._MODERATOR_DESCRIPTION_'
        };

        this.adminUser = {
            cd: 2,
            name: 'admin',
            text: 'COMPANY_SETTING.TEAM.PERMISSIONS._ADMIN_',
            description: 'COMPANY_SETTING.TEAM.PERMISSIONS._ADMIN_DESCRIPTION_'
        };

        this.companyPermissionTypes = [
            this.basicUser,
            this.moderator,
            this.adminUser
        ];

        this.companyPermissionMap = {}; //e.g. {'admin': this.adminUser, 'basic':this.basicUser,...}
        this.companyPermissionTypes.forEach(function (entry) {
            this.companyPermissionMap[entry.name] = entry;
        }.bind(this));

        PubSubService.ventMyBitchUp(this);
    }

    Services.CompanyService = Class(function () {
        return {

            constructor: CompanyServiceCtor,

            getCompanyTypesEnum: function getCompanyTypesEnum() {
                return this.companyTypeEnum;
            },

            getCompanyTypesEnumClone: function getCompanyTypesEnumClone() {
                var companyTypes = [];
                this.companyTypeEnum.forEach(function(companyType) {
                    companyTypes.push({
                        text: companyType.text,
                        key: companyType.key,
                        icon: companyType.icon
                    });
                });
                return companyTypes;
            },

            getCompanyTypesSorted: function getCompanyTypesSorted() {
                return this._.sortBy(this.companyTypeEnum, function(companyType) {
                    return companyType.order;
                });
            },

            getCompanyTypesTranslationMap: function getCompanyTypesTranslationMap() {
                return this.companyTypeTranslationMap;
            },

            getCompanyTypesInformalTranslationMap: function getCompanyTypesInformalTranslationMap() {
                return this.companyTypeInformalTranslationMap;
            },

            getCompanyTypesIconMap: function getCompanyTypesIconMap() {
                return this.companyTypeIconMap;
            },

            getSelectedCompanyTypeFromEnum: function getSelectedCompanyTypeFromEnum(company) {
                var selectedCompany = this.companyTypeEnum[0];
                this.companyTypeEnum.forEach(function (type) {
                    if (company.company_type === type.key) {
                        selectedCompany = type;
                        return;
                    }

                });

                return selectedCompany;
            },

            editTeamMembers: function editTeamMembers(company, members) {
                return this.ModalService.openNewAddCompanyTeamMemberModal(company, members);
            },



            getCompanyPermissionTypes: function getCompanyPermissionTypes() {
                return this.companyPermissionTypes;
            },

            getCompanyPermissionForUser: function getCompanyPermissionForUser(company, user) {
                if (!company || (user.company && user.company._id !== company._id)) { //make sure we are checking permissions for the right company.
                    return null;
                }

                if (user.is_company_owner) { //first check if owner
                    return this.adminUser;
                }

                //else - first check for permission settings under company
                var activePermission;
                if (company.user_permissions) { //get active permission from the company instead of the user
                    company.user_permissions.forEach(function (permission) {
                       if (permission.user_id === user._id) {
                           activePermission = permission;
                       }
                    });
                }
                if (!activePermission) { //company permissions were not found. try permission under user
                    activePermission = user.user_company_permission;
                }

                if (activePermission) { //found permission for that user
                    if (typeof activePermission.company_permission_cd === "number") {
                        return this.companyPermissionTypes[activePermission.company_permission_cd];
                    } else {
                        return this.companyPermissionMap[activePermission.company_permission];
                    }
                } else { //default to basic user
                    return this.basicUser;
                }
            },

            hasCompanyAdminPermissions: function hasCompanyAdminPermissions(user, company) {
                return this.getCompanyPermissionForUser(company, user).cd === this.adminUser.cd;
            },

            hasCompanyModeratorPermissions: function hasCompanyModeratorPermissions(user, company) {
                var permission = this.getCompanyPermissionForUser(company, user);
                return (permission.cd === this.adminUser.cd) ||
                       (permission.cd === this.moderator.cd);
            },

            isDefaultCompanyLogo: function isDefaultCompanyLogo(company) {
                var defaultImageName = 'yourlogohere.jpg';
                if (!company.logo_image || !company.logo_image.original_url) {
                    return undefined;
                }
                return (company.logo_image.original_url.indexOf(defaultImageName) > -1);
            },

            isDefaultCompanyIcon: function isDefaultCompanyIcon(company) {
                //used to work similar to isDefaultCompanyLogo, now taking from server.
                return (!company.icon_image || company.icon_image.is_default_company_icon)
            },

            getRandomCompanyCoverImage: function getRandomCompanyCoverImage(company) {
                var cover_images = company.cover_images;

                if(!cover_images || !cover_images.length) {
                    return null;
                }

                var imagePosition = Math.min(Math.floor(Math.random() * (cover_images.length + 1)), cover_images.length - 1);
                var image = cover_images[imagePosition];
                return image;
            },

            triggerCompanyBrandingUpdated: function triggerCompanyBrandingUpdated() {
                this.trigger(this.Enums.PubSubTriggers.companyBrandingUpdated);
            },

            editLeadSources: function editLeadSources(company, analyticsArgs) {
                var _analyticsArgs = analyticsArgs || {};
                _analyticsArgs['source'] = "lead_source_modal";

                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.lead_source__modal_opened, _analyticsArgs);

                return this.ModalService.openEditLeadSourceModal(company.sortedLeadSources(), function saveLeadSources(updatedLeadSourcesList) {
                    return this.CompaniesManager.updateLeadSources(company, updatedLeadSourcesList, true).then(function() {
                        company.trigger('companyLeadSourcesChanged');
                    });
                }.bind(this) , _analyticsArgs);
            },

            editProjectTypes: function editProjectTypes(company, analyticsArgs) {
                var _analyticsArgs = analyticsArgs || {};
                _analyticsArgs['source'] = "project_types_modal";

                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.project_type__modal_opened, _analyticsArgs);

                return this.ModalService.openEditProjectTypesModal(
                    company.projectTypesSort(), function saveProjectTypes(updatedProjectTypes) {
                        return this.CompaniesManager.updateProjectTypes(company, updatedProjectTypes).then(function() {
                            company.trigger('companyProjectTypesChanged');
                        });
                    }.bind(this), _analyticsArgs);
            },

        };
    });
}());
